import { createApp } from 'vue'
import { createPinia } from 'pinia'
import vuetify from '@/plugins/vuetify'
import { loadLayouts } from '@/layouts'
import { usePlugins } from '@/plugins'
import App from '@/App.vue'
import '@/scss/main.scss'
import router from '@/router'
import type { URLOpenListenerEvent } from '@capacitor/app'
import { App as CapacitorApp } from '@capacitor/app'

const app = createApp(App)

app.use(router)
app.use(vuetify)
usePlugins(app)
loadLayouts(app)
app.use(createPinia())

router.isReady().then(async () => {
  app.mount('#app')
  await CapacitorApp.addListener('appUrlOpen', async ({ url }: URLOpenListenerEvent) => {
    if (!url) return

    // remove protocol
    const slug = url.split('.app').pop()!

    // navigate to path
    await router.replace(slug)
  })
})

export default app
